import { matchPath } from "react-router-dom";
import { PRO_ROUTE_PATHS } from "./routes";

const TITLE_BY_PATH: Array<[string, string]> = [
  ["/login/*", "Sign In"],
  ["/join/offer", "Your First Offer"],
  ["/join", "Join"],
  ["/welcome", "Welcome"],
  ["/home", "Home"],
  ["/tasks", "Tasks"],
  ["/people", "People"],
  ["/people/:contactId", "Person"],
  ["/clients/:contactId/formal-offer", "Formal Offer"],
  ["/clients/:profileId", "Person"],
  ["/clients", "People"],
  ["/contacts", "People"],
  ["/campaigns", "Campaigns"],
  ["/activity", "Activity"],
  ["/profile", "Profile"],
  ["/settings", "Settings"],
  ["/preview/settings/referrals", "Settings"],
  ["/pricing", "Pricing"],
  ["/templates", "Templates"],
  ["/automations", "Automations"],
  ["/marketplace/browse/:passportID", "Make an Offer"],
  ["/marketplace/browse", "Browse Buyers"],
  ["/marketplace/standing-offers", "Standing Offers"],
  ["/marketplace/profile", "Profile"],
  ["/marketplace/offers", "Your Offers"],
  ["/marketplace/requests/:id", "Request Details"],
  ["/marketplace/requests", "Requests"],
  ["/marketplace/connections", "Connections"],
  ["/marketplace", "Marketplace"],
  ["/messages", "Messages"],
  ["/notifications", "Notifications"],
  ["/assistant", "Assistant"],
];

/** Resolve a page-name-first title without exposing route parameters or query data. */
export function getProDocumentTitle(pathname: string, search = ""): string {
  const path = pathname === "/" ? "/home" : pathname;
  let title = TITLE_BY_PATH.find(([pattern]) =>
    matchPath({ path: pattern, end: true }, path),
  )?.[1];

  // Retired routes immediately redirect; matching their destination title avoids
  // briefly putting a stale route label in the browser tab.
  if (path === PRO_ROUTE_PATHS.legacyToday) {
    title = new URLSearchParams(search).get("draft") ? "Tasks" : "Home";
  } else if (path === "/contacts" && new URLSearchParams(search).has("contact")) {
    title = "Person";
  }

  return `${title ?? "Home"} - Sill Pro`;
}
